import React from "react";

import MuiCheckbox from "@material-ui/core/Checkbox";

import { Text } from "components/Text";

import { BuyerListRow } from "./BuyerListRow";
import {
  BuyerSaleLotSummary,
  RoutingSide,
  buildColumnSummaryText,
} from "./routing";
import {
  Column,
  ColumnHeader,
  ColumnHeaderText,
  ColumnTitle,
  EmptyColumnMessage,
  RowList,
} from "./styles";

export function BuyerColumn({
  title,
  side,
  rows,
  isSelectedByBuyerId,
  onToggleSelected,
  onSelectAll,
  onMoveRow,
  saleLotSummaryByBuyerId,
  emptyMessage,
  dataTour,
}: {
  title: string;
  side: RoutingSide;
  rows: AccountingDayRoutingSuggestion[];
  isSelectedByBuyerId: Record<string, boolean>;
  onToggleSelected: (buyerId: string) => void;
  onSelectAll: (rows: AccountingDayRoutingSuggestion[]) => void;
  onMoveRow: (buyerId: string) => void;
  saleLotSummaryByBuyerId: Record<string, BuyerSaleLotSummary>;
  emptyMessage: string;
  dataTour: string;
}) {
  const selectedBuyerIds = rows
    .filter(row => isSelectedByBuyerId[row.id])
    .map(row => row.id);
  const allRowsSelected =
    rows.length > 0 && selectedBuyerIds.length === rows.length;
  const someRowsSelected = selectedBuyerIds.length > 0 && !allRowsSelected;

  const handleSelectAll = () => onSelectAll(rows);

  return (
    <Column>
      <ColumnHeader>
        <MuiCheckbox
          data-tour={dataTour}
          checked={allRowsSelected}
          indeterminate={someRowsSelected}
          disabled={rows.length === 0}
          onChange={handleSelectAll}
        />
        <ColumnHeaderText>
          <ColumnTitle>{title}</ColumnTitle>
          <Text color="gray44" fontSize="alpha">
            &middot;{" "}
            {buildColumnSummaryText(
              rows,
              selectedBuyerIds.length,
              saleLotSummaryByBuyerId,
            )}
          </Text>
        </ColumnHeaderText>
      </ColumnHeader>
      <RowList>
        {rows.map(suggestion => (
          <BuyerListRow
            key={suggestion.id}
            suggestion={suggestion}
            side={side}
            isSelected={Boolean(isSelectedByBuyerId[suggestion.id])}
            onToggleSelected={onToggleSelected}
            onMove={onMoveRow}
            lotSummary={
              saleLotSummaryByBuyerId[suggestion.id] || {
                lotCount: 0,
                totalPaidCents: 0,
              }
            }
          />
        ))}
        {rows.length === 0 && (
          <EmptyColumnMessage>{emptyMessage}</EmptyColumnMessage>
        )}
      </RowList>
    </Column>
  );
}
